import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';

import { usePermissionCheck } from 'src/hooks/permission-check.hook';
import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import { PROCESSES_MODALS } from '../../processes.constants';
import { IProcessesTableRowProps } from './processes-table.interfaces';

const ProcessesTableRowActions = ({
  record,
  handleModals,
  t,
  onClickEdit,
}: IProcessesTableRowProps) => {
  const { checkRule } = usePermissionCheck(PLATFORM_PERMISSIONS.employeeManagement);

  const isHasPermission = checkRule(PERMISSION_ACTIONS.update);

  const handleDelete = () => {
    handleModals(PROCESSES_MODALS.delete, record);
  };

  const handleEdit = () => {
    onClickEdit(record);
  };

  return (
    <Popover
      elements={[
        {
          label: t('common:buttons.edit'),
          icon: ICONS.editAlt,
          key: ICONS.editAlt,
          ...(!isHasPermission && { color: PLATFORM_THEME_COLORS.grayVariations.murky }),
          ...(isHasPermission && {
            handler: handleEdit,
          }),
        },
        {
          label: t('common:buttons.delete'),
          icon: ICONS.trash,
          color: isHasPermission
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,
          key: ICONS.trash,
          ...(isHasPermission && {
            handler: handleDelete,
          }),
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default ProcessesTableRowActions;
